import type { FC, ReactNode } from "react";

/** Fixed action area below a scrollable menu collection. */
export const SimpleMenuFooter: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="flex min-h-10 shrink-0 items-center border-t border-border-light px-1 py-1.5">
    {children}
  </div>
);
